import { render, staticRenderFns } from "./defaultUserAssignment.vue?vue&type=template&id=6ffc8582&"
import script from "./defaultUserAssignment.vue?vue&type=script&lang=js&"
export * from "./defaultUserAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports